/**
 * Linear Assets — Temporal Analysis & Spectral Multi-Timeline (Step 2)
 */

import React, { useState } from 'react';
import { Clock, Satellite, RefreshCw, BarChart2, Layers } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';

export const LinearTemporalAnalysisPage: React.FC = () => {
  const [selectedCorridor, setSelectedCorridor] = useState('lin-cor-01');

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <Clock className="w-7 h-7 text-amber-500" /> Corridor Temporal Analysis (Step 2)
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Multi-temporal satellite timeline — NDVI vegetation encroachment, thermal anomalies, and surface change along centrelines
          </p>
        </div>
        <select
          value={selectedCorridor}
          onChange={(e) => setSelectedCorridor(e.target.value)}
          className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-sm dark:text-white"
        >
          <option value="lin-cor-01">Power Line Sector 7 (275kV Feeder)</option>
          <option value="lin-cor-02">Main Western Rail Line (Sector B)</option>
          <option value="lin-cor-03">Highland Grid Interconnector (PL-12)</option>
        </select>
      </div>

      <Card>
        <div className="flex items-center justify-between mb-4 pb-2 border-b border-gray-100 dark:border-gray-800">
          <div className="flex items-center gap-2">
            <Satellite className="w-5 h-5 text-amber-500" />
            <h3 className="font-bold text-gray-900 dark:text-white">Sentinel-2 10m Multi-Spectral Passes (Last 6 Acquisitions)</h3>
          </div>
          <span className="text-xs text-gray-400">Resolution: 10m &bull; Coverage: 100% Corridor Buffer</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
          {[
            { date: '2026-08-10', meanNdvi: 0.78, delta: '+18.2%', status: 'Active Encroachment Flagged', alert: true },
            { date: '2026-07-26', meanNdvi: 0.72, delta: '+9.1%', status: 'Growth Detected', alert: false },
            { date: '2026-07-11', meanNdvi: 0.66, delta: '+0.0%', status: 'Baseline Clear', alert: false },
          ].map((pass, i) => (
            <div key={i} className={`p-4 rounded-xl border ${pass.alert ? 'border-amber-400 bg-amber-50/40 dark:bg-amber-950/20' : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800'}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-bold text-gray-900 dark:text-white">{pass.date}</span>
                <span className={`px-2 py-0.5 rounded font-bold ${pass.alert ? 'bg-amber-100 text-amber-800' : 'bg-gray-200 text-gray-700'}`}>
                  {pass.delta}
                </span>
              </div>
              <p className="text-gray-500">Mean Corridor NDVI: <strong>{pass.meanNdvi}</strong></p>
              <p className={`mt-2 font-semibold ${pass.alert ? 'text-amber-700 dark:text-amber-300' : 'text-gray-600 dark:text-gray-400'}`}>{pass.status}</p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default LinearTemporalAnalysisPage;
